import { render, staticRenderFns } from "./DashboardTotalNewCoupon.vue?vue&type=template&id=7c5c555c&"
import script from "./DashboardTotalNewCoupon.vue?vue&type=script&lang=js&"
export * from "./DashboardTotalNewCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports